// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3W2HG","box":"WorkspacesBox_box__uR04-","node":"WorkspacesBox_node__3y-qL"};